import React from "react";
import { Container } from 'react-bootstrap';
import {Link} from "react-router-dom";
import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner iotback">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">INTERNET OF <br /> THINGS</h2>
						<div className="red-border"> </div>
						<p>digiPanda provides innovative Internet of Things (IoT) consulting and business solutions to accelerate your business transformation.</p>
						<Link to="/portfolio" className="red-btn"> Explore Our Work </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
